exports.hasManagedSubmitErrors = (errors = {}) => {

    return Object.keys(errors || {}).length > 0;
};

exports.handleManagedInvalidSubmit = ({
    errors = {},
    submitInvalidFallback,
    onInvalidSubmit
}) => {

    if (!exports.hasManagedSubmitErrors(errors)) {
        return false;
    }

    if (typeof submitInvalidFallback === 'function') {
        submitInvalidFallback(errors);
        return true;
    }

    if (typeof onInvalidSubmit === 'function') {
        onInvalidSubmit(errors);
    }

    return true;
};
